/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuotationLineDto } from './quotationLineDto';
import { SupplierDto } from './supplierDto';


export interface QuotationDto { 
    id?: number;
    profile?: string;
    number?: string;
    status?: string;
    rfqUid?: string;
    eta?: Date;
    duration?: number;
    service?: boolean;
    callouts?: number;
    subTotal?: number;
    vatTotal?: number;
    total?: number;
    createdByDate?: Date;
    deleted?: boolean;
    supplier?: SupplierDto;
    lines?: Array<QuotationLineDto>;
    pvPanelBrand?: string;
    inverterBrand?: string;
    batteryBrand?: string;
}

